import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { Space } from 'antd';
import useForm from '../../../hooks/useForm';

import PageTitle from '../../PageTitle';
import FormWrapper from '../../FormWrapper';
import SaveButton from '../../buttons/SaveButton';
import CancelButton from '../../buttons/CancelButton';
import usePermissions from '../../../hooks/usePermission';

const permissionsMap = {
  canEdit: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
};

const EditTransportCostCenterForm = ({ costCenter, onSubmit, onCancel }) => {
  const { t } = useTranslation();
  const { canEdit } = usePermissions(permissionsMap);
  const { handleSubmit, value, input, setFormValue } = useForm({
    initialValue: costCenter,
    onSubmit,
    onCancel,
  });

  useEffect(() => {
    setFormValue(costCenter);
  }, [setFormValue, costCenter]);

  return (
    <>
      <form onSubmit={handleSubmit}>
        <PageTitle
          title={
            costCenter.name ||
            t('entity.taxonomy.transportCostCenter._singular')
          }
        />
        <FormWrapper>
          <FormWrapper.Single>
            <FormWrapper.Input
              label={t('entity.taxonomy.transportCostCenter.name')}
              props={{
                ...input('name'),
                disabled: value.deleted || !canEdit,
              }}
            />
            <FormWrapper.TextArea
              label={t('entity.taxonomy.transportCostCenter.description')}
              props={{
                ...input('description'),
                disabled: value.deleted || !canEdit,
              }}
            />
          </FormWrapper.Single>
        </FormWrapper>
        <Space style={{ paddingTop: '1rem' }}>
          {canEdit && <SaveButton disabled={value.deleted} />}
          <CancelButton onCancel={onCancel} />
        </Space>
      </form>
    </>
  );
};
export default EditTransportCostCenterForm;
